export default __webpack_public_path__ + "proximanova-medium-webfont.woff2";